import { qz } from "../client";
import { type QZPrintInput } from "./types";

// QZ resolves print dispatch with no payload; job ids arrive later through
// printer status callbacks.
type RuntimeQZPrint = (
  configs: QZPrintInput["configs"],
  data: QZPrintInput["data"],
  printArguments?: QZPrintInput["printArguments"],
) => Promise<void>;

const runtimePrint = qz.print as unknown as RuntimeQZPrint;

export const qzApiShowDebugMutationOptions = {
  mutationFn: async (show: boolean) => qz.api.showDebug(show),
  mutationKey: ["qz.api.showDebug"] as const,
};

export const qzPrintMutationOptions = {
  mutationFn: async ({ configs, data, printArguments }: QZPrintInput) =>
    runtimePrint(configs, data, printArguments),
  mutationKey: ["qz.print"] as const,
};
